/** L'informativa privacy di SLAB sul sito: la richiamano la spunta obbligatoria e il pie' di pagina. */
export const INFORMATIVA_PRIVACY = 'https://slabsrl.com/privacy-policy/';
